module.exports = __webpack_public_path__ + "9eab88ba506b6e600c7780a2907532f6.svg";